/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('MemberManagementDetailController', MemberManagementDetailController);

    MemberManagementDetailController.$inject = ['ActivitiesBoard', '$scope', '$rootScope', 'Principal', 'previousState', 'DataUtils', 'entity', '$state', 'MemberManagement', '$http'];

    function MemberManagementDetailController(ActivitiesBoard, $scope, $rootScope, Principal, previousState, DataUtils, entity, $state, MemberManagement, $http) {
        var vm = this;

        vm.member = entity;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.goBack = goBack;
        vm.setVerified = setVerified;
        vm.exportContact = exportContact;
        vm.university = !!vm.member.university;
        vm.save = save;

        function save() {
            vm.isSaving = true;
            var projectNotesDTO = {
                id: vm.member.id,
                notes: vm.member.commentBoard
            };
            $http.post('/api/board/profiles/comment-board', projectNotesDTO).then(onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function goBack() {
            $state.go(previousState.name, previousState.params)
        }

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setVerified () {
            vm.isVerifying = true;
            var member = angular.copy(vm.member);
            member.isVerified = true;
            MemberManagement.update(member, function () {
                $state.go('member-management-detail', null, { reload: 'member-management-detail' });
                vm.isVerifying = false;
            }, function () {
                vm.isVerifying = false;
            });
        }

        function exportContact() {
            vm.isExporting = true;
            $http.get('api/board/profiles/export/', {
                params: {
                    id: entity.id
                }
            }).then(function (response) {
                vm.isExporting = false;
                AlertService.success("Der Export wurde erfolgreich durchgeführt und an deine E-Mail Adresse geschickt.");
            });
        }

        vm.options = {
            toolbar: [
                ['style', ['bold', 'italic', 'underline', 'clear']],
                ['textsize', ['fontsize']],
                ['fontclr', ['color']],
                ['alignment', ['ul', 'ol']],
                ['view', ['codeview']]
            ]
        };

        /*
        var unsubscribe = $rootScope.$on('askApp:profileUpdate', function(event, result) {

            vm.member = result;
        });
        $scope.$on('$destroy', unsubscribe);*/
    }
})();
